import React, { useState, useEffect, useCallback } from "react";
import { Form, Button, Col, Row, Offcanvas, Tabs, Tab } from "react-bootstrap";
import { withCookies } from "react-cookie";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  addTask,
  updateTask,
  archiveTask,
  unArchiveTask,
} from "../../redux/actions/tasks";
import configVars from "../../config";
import AllComments from "../Comments/AllComments";
import History from "../History";

// Images
import noCommentImg from "../../images/noComment.png";
import PromptBox from "../PromptBox";

const Evaluation = ({
  setApiLoading,
  show,
  handleClose,
  selectedTask,
  board,
  columnId,
  selectedColumn,
  droppableColumn,
  config,
  draggableColumn,
  handleDelete,
  columnTitle,
  getColumnNo,
  setShowCloseConfirmation,
  resetInitially = false,
}) => {
  const dispatch = useDispatch();
  const [translation] = useTranslation("translations");

  const allTaskStatus = config && config["task_status"];

  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [showUpdateBtn, setShowUpdateBtn] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [result, setResult] = useState("");
  const [impact, setImpact] = useState("");
  const [resultContent, setResultContent] = useState("");
  const [impactContent, setImpactContent] = useState("");
  const [status, setStatus] = useState("");

  const allComments = selectedTask?.comments ? selectedTask.comments : [];

  const resetState = useCallback(() => {
    setTitle({ value: "", error: false });
    setImpact("");
    setResult("");
    setImpactContent("");
    setResultContent("");
    setStatus("");
    setShowUpdateBtn(false);
    setShowSaveBtn(false);
  }, []);

  useEffect(() => {
    setImpact("");
    setResult("");
    setImpactContent("");
    setResultContent("");
  }, [selectedTask]);

  useEffect(() => {
    if (resetInitially) {
      resetState();
    }
  }, [show, resetInitially, resetState]);

  useEffect(() => {
    if (selectedTask && show) {
      setTitle({ value: selectedTask.title, error: false });

      let evaluation_impact = selectedTask?.evaluation_impact;

      if (evaluation_impact) {
        const contentBlock1 = htmlToDraft(evaluation_impact);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setImpact(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setImpactContent(_contentState);
        } else {
          setImpact(null);
          setImpactContent(null);
        }
      }

      let evaluation_result = null;
      if (selectedTask?.action_plan_decided_action) {
        evaluation_result = selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        evaluation_result = selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        evaluation_result = selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        evaluation_result = selectedTask?.evaluation_result;
      }

      if (evaluation_result) {
        const contentBlock1 = htmlToDraft(evaluation_result);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setResult(editorState);
          let _contentState = convertToRaw(editorState.getCurrentContent());
          setResultContent(_contentState);
        } else {
          setResult(null);
          setResultContent(null);
        }
      }
      setStatus(selectedTask?.task_status?.term_id);
    }
  }, [selectedTask, show]);

  const handleChange = (value, field) => {
    if (setShowCloseConfirmation) {
      setShowCloseConfirmation(true);
    }

    if (!showUpdateBtn) {
      setShowUpdateBtn(true);
    }
    if (!showSaveBtn) {
      setShowSaveBtn(true);
    }
    if (field === "title") {
      setTitle({ value: value, error: false });
    } else if (field === "result") {
      setResult(value);
    } else if (field === "impact") {
      setImpact(value);
    }
  };

  const handleSubmit = async (action, archive) => {
    if (!title?.value) {
      setTitle({ ...title, error: true });
      return;
    }

    try {
      setLoading(true);
      let tasklist_id = droppableColumn
        ? droppableColumn
        : selectedColumn
        ? selectedColumn
        : columnId
        ? columnId
        : null;

      let taskObject = {
        board_id: parseInt(params?.board_id),
        title: title?.value,
        tasklist_id: tasklist_id ? parseInt(tasklist_id) : null,
        evaluation_impact: draftToHtml(impactContent),
        evaluation_result: draftToHtml(resultContent),
        task_status: status,
        post_status: "publish",
      };

      if (action === "create") {
        taskObject["parent_task_id"] = selectedTask?.id
          ? selectedTask?.id
          : null;
        await dispatch(
          addTask({
            data: taskObject,
            columnId: droppableColumn ? droppableColumn : columnId,
          })
        );
        if (archive) {
          let archiveTaskObject = {
            id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
            post_status: "archive",
          };

          await dispatch(
            archiveTask({
              data: archiveTaskObject,
              columnId: draggableColumn,
              task: selectedTask,
            })
          );
        }
      } else {
        if (selectedColumn) {
          if (!taskObject.evaluation_impact) {
            delete taskObject["evaluation_impact"];
          }
          if (!taskObject.evaluation_result) {
            delete taskObject["evaluation_result"];
          }

          taskObject["id"] = selectedTask?.id;

          await dispatch(
            updateTask({ data: taskObject, columnId: selectedColumn })
          );
        }
      }
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose(true);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleArchiveCard = async () => {
    try {
      setLoading(true);

      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "archive",
      };
      await dispatch(
        archiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUnarchiveCard = async () => {
    try {
      setLoading(true);
      let archiveTaskObject = {
        id: selectedTask?.id ? parseInt(selectedTask?.id) : null,
        post_status: "publish",
      };
      await dispatch(
        unArchiveTask({
          data: archiveTaskObject,
          columnId: selectedColumn,
          task: selectedTask,
        })
      );
      resetState();
      if (setShowCloseConfirmation) {
        setShowCloseConfirmation(false);
      }
      setLoading(false);
      setDisplayPrompt(false);
      handleClose();
    } catch (error) {
      setLoading(false);
    }
  };
  const _handleCloseLocal = () => {
    if (showUpdateBtn || showSaveBtn) {
      setDisplayPrompt(true);
    } else {
      setDisplayPrompt(false);
      handleClose();
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={() => {
        _handleCloseLocal();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen={"sm-down"}
      backdrop
      style={{ margin: "0rem", width: "70%" }}
      placement="end"
    >
      <Offcanvas.Header className="p-1" closeButton>
        <Offcanvas.Title
          className="font-weight-bold "
          style={{ width: "100%" }}
        >
          <Col
            lg="6"
            sm="12"
            className="d-flex justify-content-between align-item-center m-2"
          >
            <h3 className="d-flex mb-0 align-items-center">
              <span className="d-flex align-items-center mx-2  justify-content-center bg-sustaingul text-white title-number-background">
                5
              </span>
              {columnTitle}
            </h3>
            {showSaveBtn && !selectedTask ? (
              <Button
                // save button / spara button
                style={{
                  height: "43px",
                  fontSize: "13px",
                  borderRadius: "32px",
                }}
                variant="sustaingul text-white rounded px-3 mx-3"
                onClick={() => handleSubmit("create")}
                disabled={loading}
                className="save-new-card"
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.save")
                )}
              </Button>
            ) : null}
            {showUpdateBtn && selectedTask && !droppableColumn ? (
              <Button
                style={{
                  height: "32px",
                  padding: "0px 0px",
                  fontSize: "13px",
                }}
                variant="sustaingul text-white rounded"
                onClick={() => handleSubmit("update")}
                className="mx-3 px-3 pull-right update-selected"
                disabled={loading}
              >
                {loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  translation("buttons.update")
                )}
              </Button>
            ) : null}
          </Col>
          <Col lg="6" sm="12"></Col>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0 evaluation">
        {setApiLoading ? (
          <div className="container-fluid px-3">
            <div className="d-flex justify-content-center mt-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </div>
        ) : (
          <Row>
            <Col
              lg="6"
              sm="12"
              style={{ overflowY: "scroll", height: "100vh" }}
            >
              <Form>
                <div className="">
                  <div className="d-lg-flex flex-lg-column">
                    <Form.Group className="mb-3  pt-2">
                      <Form.Label>
                        <b className="text-capitalize">
                          {translation("title")}
                        </b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={title?.value
                          .substring(0, 45)
                          .replaceAll("&amp;", "&")}
                        onChange={(e) => {
                          handleChange(e.target.value, "title");
                        }}
                        isInvalid={title?.error}
                        style={{
                          fontSize: "14px",
                          padding: "0.5rem 0.5rem",
                          borderRadius: "0px",
                        }}
                      />
                      {title?.error && (
                        <Form.Control.Feedback type="invalid">
                          {translation("title_empty_warning")}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  </div>
                </div>

                <div className="d-flex ">
                  <Form.Label>
                    <b>{translation("status")}</b>
                  </Form.Label>
                </div>
                <div className="d-flex justify-content-left">
                  {config &&
                    allTaskStatus &&
                    Object.keys(allTaskStatus)?.map((item, index) => {
                      return (
                        <div className=" " key={index}>
                          <button
                            style={{
                              height: "32px",
                              width: "90px",
                              padding: "0px 0px",
                              fontSize: "13px",
                              borderRadius: "32px",
                              marginRight: "10px",
                            }}
                            type="button"
                            className={`btn border-1 ${
                              status === allTaskStatus[item].term_id
                                ? `btn-sy-${allTaskStatus[item].slug} text-white`
                                : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                            }`}
                            onClick={() => {
                              setStatus(allTaskStatus[item].term_id);
                              if (setShowCloseConfirmation) {
                                setShowUpdateBtn(true);
                                setShowSaveBtn(true);
                                setShowCloseConfirmation(true);
                              }
                            }}
                          >
                            {allTaskStatus[item]?.name}
                          </button>
                        </div>
                      );
                    })}
                </div>

                <Form.Group className=" mt-3">
                  <Form.Label>
                    <b>{translation("result")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={result}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => {
                      handleChange(e, "result");
                    }}
                    onChange={(e) => {
                      setResultContent(e);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <b>{translation("impact")}</b>
                  </Form.Label>

                  <Editor
                    toolbarOnFocus
                    toolbar={configVars?.wysiwygToolbarOptions}
                    editorState={impact}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="editor-wrapper"
                    onEditorStateChange={(e) => {
                      handleChange(e, "impact");
                    }}
                    onChange={(e) => {
                      setImpactContent(e);
                    }}
                  />
                </Form.Group>
              </Form>
              <div>
                {selectedTask && droppableColumn ? (
                  <Row>
                    <div className="me-5 task-moved">
                      <Button
                        variant="sustaingul text-white rounded"
                        onClick={() => handleSubmit("create", false)}
                        disabled={loading}
                        className="mb-2"
                        style={{ height: "43px" }}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text3"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>

                      <Button
                        style={{
                          borderRadius: "32px",
                          marginRight: "10px",
                          height: "43px",
                        }}
                        variant="sustaingul text-white rounded"
                        onClick={() => handleSubmit("create", true)}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <>
                            {translation("buttons.save_and_archive.text1")}
                            <b>
                              {" "}
                              {translation(
                                "buttons.save_and_archive.text4"
                              )}{" "}
                            </b>
                            {translation("buttons.save_and_archive.text2")}
                          </>
                        )}
                      </Button>
                    </div>
                  </Row>
                ) : selectedTask && selectedColumn ? (
                  <div
                    className="d-flex justify-content-left task-btns"
                    style={{ width: "100%" }}
                  >
                    <div className="update-exist">
                      <Button
                        // update button bottom section
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          borderRadius: "32px",
                          marginRight: "10px",
                        }}
                        variant="sustaingul text-white rounded px-3"
                        onClick={() => handleSubmit("update")}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.update")
                        )}
                      </Button>
                    </div>
                    <div className="archive-delete">
                      {selectedTask?.post_status === "publish" ? (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            borderRadius: "32px",
                            marginRight: "10px",
                          }}
                          variant="sustaingul text-white rounded px-3"
                          onClick={() => {
                            handleArchiveCard();
                          }}
                          className="archive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.archive_card")
                          )}
                        </Button>
                      ) : (
                        <Button
                          style={{
                            height: "32px",
                            padding: "0px 0px",
                            fontSize: "13px",
                            borderRadius: "32px",
                            marginRight: "10px",
                          }}
                          variant="sustaingul text-white rounded px-3"
                          onClick={() => {
                            handleUnarchiveCard();
                          }}
                          className="unarchive-card"
                          disabled={loading}
                        >
                          {loading ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              style={{ color: "#fff" }}
                            />
                          ) : (
                            translation("buttons.unarchive_card")
                          )}
                        </Button>
                      )}
                      <Button
                        style={{
                          height: "32px",
                          padding: "0px 0px",
                          fontSize: "13px",
                          borderRadius: "32px",
                          marginRight: "10px",
                        }}
                        variant="sustaingul text-white rounded px-3"
                        onClick={() => handleDelete()}
                        className="delete-card"
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          translation("buttons.delete_card")
                        )}
                      </Button>
                      <div className="mb-5" />
                    </div>
                  </div>
                ) : (
                  <Button
                    // save button / spara button
                    style={{
                      height: "43px",
                      fontSize: "13px",
                      borderRadius: "32px",
                      marginRight: "10px",
                    }}
                    variant="sustaingul text-white rounded px-3"
                    onClick={() => handleSubmit("create")}
                    disabled={loading}
                    className="save-card"
                  >
                    {loading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#fff" }}
                      />
                    ) : (
                      translation("buttons.save")
                    )}
                  </Button>
                )}
              </div>
            </Col>
            <Col lg="6" sm="12">
              {!selectedTask ? (
                <div className="d-flex justify-content-center align-items-center h-100 new-card-comment">
                  <img
                    src={noCommentImg}
                    alt="No-Comments"
                    style={{ width: "200px" }}
                  />
                </div>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="commentsKey"
                    id="uncontrolled-tab-example"
                    className="mb-3 sustain-tabs bg-white"
                    fill
                  >
                    <Tab
                      eventKey="commentsKey"
                      title={translation("task_forms.comments.commentsHeading")}
                    >
                      {selectedTask && droppableColumn ? (
                        <div className="d-flex justify-content-center align-items-center no-comments-container">
                          <img
                            src={noCommentImg}
                            alt="No-Comments"
                            style={{ width: "200px" }}
                          />
                        </div>
                      ) : (
                        <AllComments
                          task_id={selectedTask?.id}
                          color="sustaingul"
                          taskComments={allComments}
                          tasklist_id={
                            columnId
                              ? columnId
                              : droppableColumn
                              ? droppableColumn
                              : selectedColumn
                              ? selectedColumn
                              : null
                          }
                        />
                      )}
                    </Tab>
                    <Tab eventKey="history" title={translation("history")}>
                      <div className="col-12 px-2">
                        <History
                          taskDate={selectedTask.task_date}
                          history={selectedTask?.history}
                          getColumnNo={getColumnNo}
                          config={config}
                        />
                      </div>
                    </Tab>
                  </Tabs>
                </>
              )}
            </Col>
            <PromptBox
              show={displayPrompt}
              handleClosePrompt={() => {
                setShowCloseConfirmation(false);
                setShowUpdateBtn(false);
                setShowSaveBtn(false);
                setTimeout(() => {
                  setDisplayPrompt(false);
                  handleClose();
                }, 100);
              }}
              title={translation("changes_not_saved")}
              message={translation("select_changes")}
              handleClose={() => {
                setDisplayPrompt(false);
              }}
              handleSave={() => {
                if (selectedTask) {
                  handleSubmit("update");
                } else {
                  handleSubmit("create");
                }
              }}
              isLoading={loading}
            />
          </Row>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default withCookies(Evaluation);
